import React from 'react';

import { User } from '@project44/ui-utils';
import { DtoBase, UserModels } from '@project44-models/iam-gateway';

import { UIFormClient } from '../../../../../external/UIFormClient/domain/abstract/UIFormClient';
import { ReactComponent } from '../../../../../shared/abstract/infrastructrue/ReactComponent';
import { TApiDataState } from '../../../../../shared/core/domain/interfaces';
import { UserCreationFormTemplate } from '../../../domain/forms/templates/UserCreationFormTemplate';
import {
  IUserCreationForm,
  TUserCreationFormComponent,
} from '../../../domain/interfaces';
import { UserDomainSchemas } from '../../../index';
import { UserCreationForm } from './UserCreationForm';
import {
  TUserCreationFormView,
  UserCreationFormView,
} from './UserCreationForm.view';

export class UserCreationFormComponent extends ReactComponent {
  public readonly validationSchema = UserDomainSchemas.userCreationSchema;

  public properties: UIFormClient<IUserCreationForm>['properties'];

  constructor(
    private readonly userCreationFormTemplate: UserCreationFormTemplate,
    private readonly userPrincipal: User,
  ) {
    super();
    this.properties =
      userCreationFormTemplate.compose(userPrincipal).properties;
  }

  public redirectAfterUserCreation(
    apiDataState: TApiDataState<{
      user: DtoBase<UserModels.UserViewModel>;
    }>,
    afterUserCreationActionHandler?: (
      user: DtoBase<UserModels.UserViewModel>,
    ) => void,
  ): void {
    const { isLoading, data, error } = apiDataState;

    if (!isLoading && error === undefined && !!data?.user) {
      afterUserCreationActionHandler?.(data.user);
    }
  }

  public static readonly create = ({
    userCreationFormTemplate,
    userPrincipal,
    useUserCreatorConfig,
    afterUserCreationActionHandler,
  }: TUserCreationFormComponent): React.ReactElement<TUserCreationFormView> => {
    return ReactComponent.withAnyOfPermissionsHOC<TUserCreationFormView>(
      ['system-admin:create:users', 'SAVE_USER_ROLES'],
      UserCreationFormView,
      {
        userPrincipal,
        useUserCreatorConfig,
        afterUserCreationActionHandler,
        user: userPrincipal,
        UserFormCreator: UserCreationForm.compose(
          userCreationFormTemplate,
          userPrincipal,
        ),
        userCreationFormComponent: new UserCreationFormComponent(
          userCreationFormTemplate,
          userPrincipal,
        ),
        transformUserCreationForm:
          userCreationFormTemplate.transformUserCreationForm,
      },
    );
  };
}
